;(function() {
  'use strict'

  controller.$inject = ["$scope", "glDialog", "siteService"];
  angular.module('app.public').controller('Public', controller)

  /* @ngInject */
  function controller($scope, glDialog, siteService) {
    $scope.newsletter = {}
    $scope.submitNewsletter = submitNewsletter

    function submitNewsletter() {
      if ($scope.newsletterForm.$invalid) {
        return glDialog.alert('', 'Please enter your name and email.')
      }

      $scope.newsletter.isSending = true
      siteService
        .newsletter($scope.newsletter)
        .then(function() {
          console.log('x1')
        })
        .catch(function() {
          console.log('x2')
        })
        .finally(function() {
          $scope.newsletter.isSending = false
          $scope.newsletter.isSent = true
        })
    }
  }
})()
